import { GATEWAY_URL } from "../Helper";
import { useApiMiddleware } from "./useApiMiddlware";

export const useApi = () => {
    const apiMiddleware = useApiMiddleware()
  return {
    customRequest: (url, options, callback) => apiMiddleware(url, options, callback),
    login: (username, password, deviceId, callback) => apiMiddleware(GATEWAY_URL + "/login", { method: "POST", body: JSON.stringify({username: username, password: password, deviceId: deviceId} ), callback})
  };
};